import { Model } from 'app/model/backendmodel';
import { HttpServerLocation } from 'app/model/dataset/location/http-server.location';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Named, Owned } from 'app/model/base/named';
import { IHttpConnectionLocationContext } from 'app/interfaces/copilot.pipeline.action.types';
import { BaseAdapter, ILocationPath } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(HttpServerLocation)
})
export class HttpServerLocationAdapter extends BaseAdapter<
    HttpServerLocation,
    Model.DatasetLocation,
    IHttpConnectionLocationContext
> {
    public override toFabricCopilotContext(location: HttpServerLocation): IHttpConnectionLocationContext {
        if (location) {
            const filePath = location.getParameterizedLocation();
            const result: IHttpConnectionLocationContext = {
                Url: filePath.fileName
            };
            return result;
        }
        return undefined;
    }

    public override fromFabricCopilotContext(
        context: IHttpConnectionLocationContext,
        model?: HttpServerLocation
    ): HttpServerLocation {
        if (context) {
            const filePath: ILocationPath = {
                fileName: context.Url
            };
            model.setParameterizedLocation(filePath);
        }
        return model;
    }
    public _toResource(store: HttpServerLocation): Model.HttpServerLocation {
        const resource: Model.HttpServerLocation = {
            type: 'HttpServerLocation',
            relativeUrl: ValueAdapter.toResource(store, HttpServerLocation.RELATIVE_URL) || undefined
        };
        return resource;
    }

    public _toModel(resource: Model.HttpServerLocation, owner: Named): HttpServerLocation {
        const model = Owned.create<HttpServerLocation>(HttpServerLocation.MODEL, owner);
        ValueAdapter.toModel(model, HttpServerLocation.RELATIVE_URL, resource.relativeUrl);
        return model;
    }
}
